/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
} from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Visibility from '@material-ui/icons/Visibility';
import {
  acceptApplicant,
  checkAffiliateStudentOrganization,
  getCandidature,
  getDegree,
  getFormationsMap,
  getInfosDashboard,
  getTrainingType,
  rejectApplicant,
} from '@webapps/business';
import {
  Modal,
  ModalSideBar,
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { default as ModalStep } from 'components/Modal';
import { default as ModalLarge } from 'components/ModalLarge';
import Profil from 'components/Profil';
import ProfilName from 'components/Profil/Components/ProfilName';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import AffiliationSend from './Affiliation';
import CardCandidat from './CardCandidat';
import CreateFormation from './CreateFormation';
import InfoCandidat from './InfoCandidat';
import MessageBox from 'components/MessageBox';
import ModalProfilCandidat from './ModalProfilCandidat';
import Information from 'components/Icons/Information';
import theme from '../theme';
import Nodata from 'components/NoData';

// import Profil from './Profil';

const STATUS = [
  { label: 'Tous les statuts', value: 'all' },
  { label: 'En attente', value: 'pending' },
  { label: 'Accepté(e)', value: 'accepted' },
  { label: 'Refusé(e)', value: 'rejected' },
];

const INTEREST_LEVEL = [
  { label: 'Tous les niveaux', value: 'all' },
  { label: 'Neutre', value: 1 },
  { label: 'Faible', value: 2 },
  { label: 'Moyen', value: 3 },
  { label: 'Elevé', value: 4 },
];

const IS_READ = [
  { label: 'Oui et Non', value: 'all' },
  { label: 'Oui', value: 'true' },
  { label: 'Non', value: 'false' },
];

const Candidats = ({ handleCandidatsLength, handleUnexaminedCandidates, refetchDashboardInfo }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();

  const location = useLocation();
  const [age, setAge] = useState('');
  const { idUser } = useAuth();
  const { addToast } = useToast();
  const [keyword, setKeyword] = useState('');
  const [training, setTraining] = useState('');
  const [trainingType, setTrainingType] = useState('');
  const [status, setStatus] = useState('');
  const [isRead, setIsRead] = useState('');
  const [degree, setDegree] = useState('');
  const [interestLevel, setInterestLevel] = useState('');
  const [candidatId, setCandidatId] = useState(0);
  const [openInfoCandidat, setOpenInfoCandidat] = useState(false);
  const [openSendMessage, setOpenSendMessage] = useState(false);

  const {
    images: { Candidate }
  } = theme

  const handleCloseInfoCandidat = () => {
    setOpenInfoCandidat(false);
  };

  const handleCloseSendMessage = () => {
    setOpenSendMessage(false);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const viewMember = (id) => {
    setCandidatId(id);
    setOpenInfoCandidat(true);
  };
  const contactMember = (id, idTraining) => {
    setCandidatId(id);
    setIdSelectTraining(idTraining);
    setOpenSendMessage(true);
  };
  const transfertDocument = (id) => {
    // eslint-disable-next-line no-console
  };

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [stepAffilation, setStepAffiliation] = useState(1);

  const {
    status: load,
    data: { content: candidatures = [], totalElements } = {},
    refetch: refetchCandidatures,
    isFetching,
    isLoading: isLoadingCandidatures,
  } = useQuery(getCandidature, {
    key: [
      'cadidatures',
      page +
      training +
      status +
      degree +
      interestLevel +
      keyword +
      isRead +
      trainingType,
    ],
    variables: {
      keyword,
      training,
      status,
      isRead,
      degree,
      interestLevel,
      trainingType,
      id: idUser,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: { content: formations = [] } = {}, refetch } = useQuery(
    getFormationsMap,
    {
      key: ['formationss', page + idUser + keyword],
      variables: {
        schools: idUser,
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: degrees = [] } = useQuery(getDegree, {
    key: 'degreeMap',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'trainingTypeMap',
  });

  const {
    isLoading: isLoadingAcceptApplicantCandidature,
    isSuccess: isSuccessAcceptApplicantCandidature,
    mutateAsync: mutateAcceptApplicantCandidature,
  } = useMutation(acceptApplicant);

  const {
    data: dataCheckAffiliate,
    isLoading: isLoadingCheckAffiliate,
    isSuccess: isSuccessCheckAffiliate,
    mutateAsync: mutateCheckAffiliate,
  } = useMutation(checkAffiliateStudentOrganization);

  const {
    isLoading: isLoadingRejectApplicantCandidature,
    isSuccess: isSuccessRejectApplicantCandidature,
    mutateAsync: mutateRejectApplicantCandidature,
  } = useMutation(rejectApplicant);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [addModalAffiliation, setAddModalAffiliation] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState();
  const [selectedTraining, setSelectedTraining] = useState();

  const handleOpenAddAffiliation = () => {
    setAddModalAffiliation(true);
  };
  const handleCloseAddAffiliation = () => {
    setAddModalAffiliation(false);
    setStepAffiliation(1);
  };

  const checkAffilate = async (student, idTraining) => {
    setSelectedApplicant(student);
    setSelectedTraining(idTraining);
    await mutateCheckAffiliate({
      organizationId: idUser,
      studentId: student?.id,
    });
  };

  useEffect(() => {
    if (isSuccessCheckAffiliate) {
      if (dataCheckAffiliate) {
        addToast({
          status: 'success',
          message: 'Une affiliation est déjà en cours avec cet étudiant',
        });
      } else {
        handleOpenAddAffiliation();
      }
    }
  }, [isSuccessCheckAffiliate]);

  const [viewProfil, setViewProfil] = useState(false);

  const { push } = useRouter();

  const [idSelect, setIdSelect] = useState(0);
  const [idSelectTraining, setIdSelectTraining] = useState(0);
  const [levelInterest, setLevelInterest] = useState(0);
  const [candidatureResponse, setCandidatureResponse] = useState('');
  const [candidatureRead, setCandidatureRead] = useState(false);
  const [stepModal, setStepModal] = useState(1);

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const viewCV = (id, idTraining, level, candidatureResponse, candidatureRead, candidatureInfo) => {
    setIdSelect(id);
    setIdSelectTraining(idTraining);
    setLevelInterest(level);
    setCandidatureResponse(candidatureResponse);
    setCandidatureRead(candidatureRead)
    handleOpenViewProfil();
  };

  const accepetApplicantCandidature = async (idApplicant, idTraining) => {
    await mutateAcceptApplicantCandidature({
      trainingId: idTraining,
      applicantId: idApplicant,
    });
  };

  const rejectApplicantCandidature = async (idApplicant, idTraining) => {
    await mutateRejectApplicantCandidature({
      trainingId: idTraining,
      applicantId: idApplicant,
    });
  };

  useEffect(() => {
    if (isSuccessAcceptApplicantCandidature) {
      addToast({
        status: 'success',
        message: 'Candidature acceptée',
      });
      refetchCandidatures();
    }
  }, [isSuccessAcceptApplicantCandidature]);

  useEffect(() => {
    if (isSuccessRejectApplicantCandidature) {
      addToast({
        status: 'success',
        message: 'Candidature refusée',
      });
      refetchCandidatures();
    }
  }, [isSuccessRejectApplicantCandidature]);

  const searchKeyword = (e) => {
    // if (e.target.value) {
    setKeyword(e.target.value);
    setPage(1);
    // }
  };

  const searchTraining = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setTraining('') : setTraining(e.target.value);
      setPage(1);
    }
  };

  const searchTrainingType = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setTrainingType('')
        : setTrainingType(e.target.value);
      setPage(1);
    }
  };

  const searchStatus = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setStatus('') : setStatus(e.target.value);
      setPage(1);
    }
  };

  const searchDegree = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setDegree('') : setDegree(e.target.value);
      setPage(1);
    }
  };

  const searchInterestLevel = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setInterestLevel('')
        : setInterestLevel(e.target.value);
      setPage(1);
    }
  };

  const searchIsRead = (e) => {
    if (e.target.value) {
      e.target.value === 'all' ? setIsRead('') : setIsRead(e.target.value);
      setPage(1);
    }
  };

  useEffect(() => {
    const unexaminedCandidatesCount = candidatures.filter(candidature => !candidature.read).length;
    candidatures.filter(candidature => {

    })

    handleUnexaminedCandidates(unexaminedCandidatesCount);
  }, [candidatures, handleUnexaminedCandidates]);

  useEffect(() => {
    handleCandidatsLength(totalElements);
  }, [totalElements]);

  const handleViewCvtheque = () => {
    push(ROUTES_PATH.CVTHEQUE_SCHOOL, { params: { id: idUser } });
  };

  const [openCreateFormation, setOpenCreateFormation] = useState(false);

  const handleOpenCreateFormation = () => {
    setOpenCreateFormation(true);
  };

  const handleCloseCreateFormation = () => {
    setOpenCreateFormation(false);
  };

  useEffect(() => {
    if (location.state?.openCreateFormation) {
      handleOpenCreateFormation();
      location.state.openCreateFormation = false;
    }
  }, [location]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 20,
        height: '100%',
      }}
    >
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: spacing(2), // espacement entre les éléments
          '@media (max-width: 1028px)': {
          },
          '@media (max-width: 768px)': {
            flexDirection: 'column',
          },
        })}
      >
        <TextField
          id="outlined-basic"
          label="Prénom et nom"
          onChange={(e) => searchKeyword(e)}
          size="small"
          variant="outlined"
          borderRadius={30}
          endAdornment={<Search style={{ color: '#5D75A8' }} />}
        />
        <div className={classes.selectInput}>
          <TextField
            label="Offre de formation"
            name="offer"
            fullWidth
            onChange={(e) => searchTraining(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Toutes les offres</MenuItem>
            {formations.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            label="Niveau de diplôme"
            name="degree"
            fullWidth
            onChange={(e) => searchDegree(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les niveaux</MenuItem>
            {degrees.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            label="Type de formation"
            name="trainingType"
            fullWidth
            onChange={(e) => searchTrainingType(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les types de formation</MenuItem>
            {trainingTypes.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            label="Statut de candidature"
            name="status"
            fullWidth
            onChange={(e) => searchStatus(e)}
            select
            borderRadius={30}
          >
            {STATUS.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            label="Niveau d'intérêt"
            name="interest"
            fullWidth
            onChange={(e) => searchInterestLevel(e)}
            select
            borderRadius={30}
          >
            {INTEREST_LEVEL.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className={classes.selectInput}>
          <TextField
            label="Profils examinés"
            name="isRead"
            fullWidth
            onChange={(e) => searchIsRead(e)}
            select
            borderRadius={30}
          >
            {IS_READ.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>

      <div className={classes.formations}>
        <Grid
          className={css({
            '@media only screen and (max-width: 1023px)': {
              maxHeight: '100%',
            },
            overflow: 'auto',
            height: '100%'
          })}
        >
          {isLoadingCandidatures ? (
            <Grid
              container
              className={css({
                padding: spacing(0, 0, 2.5, 2.5),
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
              })}
            >
              {[...Array(size/2)].map((_, index) => (
                <CardCandidat key={index} isLoading={true} />
              ))}
            </Grid>
          ) : !candidatures?.length ? (
            <Grid item xs={12} className={classes.noDataContainer}>
              <Nodata
                image={Candidate}
                contentWidth='70%'
                width="150px"
                padding='0px 20px 20px 0px'
                title="Aucun candidat trouvé"
                description="Les candidatures reçues pour vos formations apparaîtront ici."
              />
            </Grid>
          ) : (
            <Grid
              container
              className={css({
                padding: spacing(0, 0, 2.5, 2.5),
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
              })}
            >
              {candidatures.map((candidature, index) => (
                <CardCandidat
                  key={index}
                  candidature={candidature}
                  viewCV={viewCV}
                  contactMember={contactMember}
                  addAffiliation={checkAffilate}
                  acceptCandidature={accepetApplicantCandidature}
                  rejectCandidature={rejectApplicantCandidature}
                />
              ))}
            </Grid>
          )}
        </Grid>
      </div>
      {candidatures?.length > 0 && totalElements > 12 && (
        <div className={classes.pagination}>
          <PaginationNumbers
            onChange={handlePaginationChange}
            noMargin={true}
            page={page}
            pageCount={12}
            totalCount={totalElements}
          />
        </div>
      )}
      <Modal
        nbStep={5}
        onCancel={handleCloseCreateFormation}
        open={openCreateFormation}
        step={stepModal}
        title={intl.formatMessage({
          id: 'school.formationsCandidats.publierFormation',
        })}
      >
        <div className={classes.text}>
          <div className={css({ display: 'flex', flexDirection: 'row' })}>

            <div>
              <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
            </div>
            <div>
              Permettez aux candidats retrouver votre offre dans “Postuler” et d’y
              candidater en un seul clic.
              <br /> Publier une formation vous permets également de la lier à une
              classe pour obtenir plus de fonctionnalités.
              <br /> Pour en savoir plus, veuillez lire la Base de connaissance.
            </div>
          </div>
        </div>
        <CreateFormation
          onChangeStepModal={setStepModal}
          onClose={handleCloseCreateFormation}
          refetchFormation={refetch}
        />
      </Modal>
      <ModalProfilCandidat
        onCancel={handleCloseInfoCandidat}
        open={openInfoCandidat}
      >
        <InfoCandidat id={candidatId} />
      </ModalProfilCandidat>
      <Modal
        onCancel={handleCloseSendMessage}
        open={openSendMessage}
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={idSelect} onCancel={handleCloseSendMessage} />
      </Modal>
      <ModalStep
        nbStep={2}
        onCancel={handleCloseAddAffiliation}
        open={addModalAffiliation}
        step={stepAffilation}
        // subTitle="Affiliez un candidat et demandez des documents"
        title="Ajouter un candidat dans vos affilliations"
      >
        <AffiliationSend
          applicant={selectedApplicant}
          onChangeStepAffiliation={setStepAffiliation}
          onClose={handleCloseAddAffiliation}
          selectedTraining={selectedTraining}
        />
      </ModalStep>
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={idSelect} />}
      >
        <Profil
          id={idSelect}
          level={levelInterest}
          idTraining={idSelectTraining}
          refetch={refetchCandidatures}
          candidatureResponse={candidatureResponse}
          candidatureRead={candidatureRead}
          acceptCandidature={accepetApplicantCandidature}
          rejectCandidature={rejectApplicantCandidature}
          refetchDashboardInfo={refetch}
        />
      </ModalSideBar>
    </div>
  );
};

const styles = ({ spacing }) => ({
  stepStyles: {
    margin: '10px 0 0 0',
  },
  formations: { flex: 1 },
  infoCandidat: { display: 'flex' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  selectInput: {
    width: '200px',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F3F7FF',
    borderRadius: 12,
    height: 'calc(100vh - 75px - 243px)',
    '@media only screen and (max-width:1279px)': {
      height: 'calc(100vh - 75px - 343px)',
    },
    '@media screen and (max-width: 768px)': {
      padding: '20px',
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: spacing(2),
  },
});

const ImageProfil = ({ applicant }) => {
  const { css } = useStyles();
  const { data: infos = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', applicant?.id],
    variables: { id: applicant?.id },
  });

  return infos?.profile?.profileImageUrl ? (
    <Avatar
      className={css({
        height: 50,
        width: 50,
      })}
      src={infos?.profile?.profileImageUrl}
    />
  ) : (
    <Avatar
      className={css({
        height: 50,
        width: 50,
      })}
    >
      {applicant?.lastname?.substr(0, 1)} {applicant?.firstname?.substr(0, 1)}
    </Avatar>
  );
};

ImageProfil.propTypes = {
  applicant: PropTypes.object,
};

export default Candidats;
